<div class="grid-container" *ngIf="itemLength > 2">
  <div class="grid-item" *ngFor="let item of items" [style.border-color]="item.color">
    <h3 class="title">
      {{ item.dimension }}<br>
      <span class="subtitle">{{ item.name }}</span>
    </h3>
    <p class="description">{{ item.summary }}</p>
  </div>
</div>
